module.exports = __webpack_public_path__ + "img/010.0a438747.jpg";